import React from 'react';
import PropTypes from 'prop-types';

import {
	Typography,
	makeStyles,
	Grid
} from '@material-ui/core';

import Timestamp from './Timestamp.js';
import AvatarRowWithCol from './AvatarRowWithCol.js';

const styles = makeStyles(theme => ({
	avatarRow: {
		paddingTop: theme.spacing(3)
	}
}));

function Comment(props) {
	let classes = styles(),
		{ready, authorName, avatar, content, time} = props;

	return (
		<AvatarRowWithCol
			ready={ready}
			authorImage={avatar}
			authorName={authorName}
			className={classes.avatarRow}>
			<Grid
				container
				direction="column"
				justify="flex-start"
				alignItems="stretch">
				<Grid item>
					<Typography variant="body1">{authorName}</Typography>
				</Grid>
				<Grid item>
					<Typography>{content}</Typography>
				</Grid>
				<Grid item>
					<Timestamp time={time} />
				</Grid>
			</Grid>
		</AvatarRowWithCol>
	);
}

Comment.propTypes = {
	authorName: PropTypes.string,
	avatar: PropTypes.string,
	content: PropTypes.string,
	time: PropTypes.string,
	ready: PropTypes.bool
};

export default Comment;
